import React, { useEffect, useState, createContext } from 'react';
import { getAccesTokenApi, getRefreshTokenApi, refreshAccessTokenApi, logout } from '../api/auth';
import { getUserApi } from '../api/user';
import jwtDecode from 'jwt-decode';

export const AuthContext = createContext();

export default function AuthProvider(props) {
	const { children } = props;
	//const [isLoading, setIsLoading] = useState(false);
	//const [userBD, setUserBD] = useState([]);

	const [user, setUser] = useState({
		user: null,
		userBD: null,
		isLoading: true,
	});

	useEffect(() => {
		checkUserLogin(setUser);
	}, []);

	return <AuthContext.Provider value={user}>{children}</AuthContext.Provider>;
}

function checkUserLogin(setUser) {
	const accessToken = getAccesTokenApi();
	if (!accessToken) {
		const refreshToken = getRefreshTokenApi();
		if (!refreshToken) {
			logout();
			setUser({
				user: null,
				userBD: null,
				isLoading: false,
			});
		} else {
			refreshAccessTokenApi(refreshToken).then((result) => {
				if (result === '') {
					setUser({
						user: null,
						userBD: null,
						isLoading: false,
					});
				} else {
					let userData = jwtDecode(result);
					getUserApi(result, userData.data.id).then((result) => {
						setUser({
							user: jwtDecode(result),
							userBD: result.resultado[0],
							isLoading: false,
						});
					});
				}
			});
		}
	} else {
		let userData = jwtDecode(accessToken);
		getUserApi(accessToken, userData.data.id).then((result) => {
			setUser({
				user: jwtDecode(accessToken),
				userBD: result.resultado[0],
				isLoading: false,
			});
		});
	}
}
